export const GROUPS_LOAD = 'GROUPS_LOAD';
export const GROUPS_LOAD_SUCCESS = 'GROUPS_LOAD_SUCCESS';
export const GROUPS_LOAD_ERROR = 'GROUPS_LOAD_ERROR';
export const GROUP_LOAD = 'GROUP_LOAD';
export const GROUP_LOAD_SUCCESS = 'GROUP_LOAD_SUCCESS';
export const GROUP_LOAD_ERROR = 'GROUP_LOAD_ERROR';
export const GROUPS_UPDATE_SUCCESS = 'GROUPS_UPDATE_SUCCESS';
export const GROUP_ADD ='GROUP_ADD';
export const GROUP_ADD_SUCCESS ='GROUP_ADD_SUCCESS';
export const GROUP_ADD_ERROR ='GROUP_ADD_ERROR';
export const GROUP_UPDATE ='GROUP_UPDATE';
export const GROUP_UPDATE_SUCCESS ='GROUP_UPDATE_SUCCESS';
export const GROUP_UPDATE_ERROR ='GROUP_UPDATE_ERROR';
export const GROUP_DELETE = 'GROUP_DELETE';
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS';
export const GROUP_DELETE_ERROR = 'GROUP_DELETE_ERROR';
export const GROUP_DUPLICATE = 'GROUP_DUPLICATE';
export const GROUP_DUPLICATE_SUCCESS = 'GROUP_DUPLICATE_SUCCESS';
export const GROUP_DUPLICATE_ERROR = 'GROUP_DUPLICATE_ERROR';